import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
import AccountResources from './../Account/Resources/commonfunctions.js';


let service = new services();
export default {
    name: 'Sellpoint',
    mixins: [AccountResources],
    data () {
        return {
           user:{},
            categories:{},
            market:{},
            market_groups:{},
            market_trending:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view:{},
            show_login:false,
            show_landing:true,
            header_data:{},
            has_shops:true,
            //
            set_view_box:'',
            set_view_box_2:'',
            set_order_options_item_index:0,
            set_product_order_options:{},
            //
            product_index:0,
            product_item_index:0,
            //
            headerComponentKey:0,
            //
            set_categories:[],
            //
            set_app_operator:false,
            business_display_image:'/static/assets/images/order00.jpg',
            //
            back_track:0, //for handling route-browser-back to-do event
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-sticky-header': MainHeader,
        'component-footer': MainFooter,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.setUserOrderDetails(); //also call at order component template load
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                   // self.show_login=true;
                    // self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setUserOrderDetails(){
            //ini setts
            this.user.user_order_delivery_state = '';
            this.user.user_order_delivery_city_id = 0;
            this.user.user_order_delivery_city = '';
            this.user.user_order_delivery_address = '';
            //
            this.user.user_order_city_delivery_addresses = {};
            this.user.user_delivery_addresses = {};
            this.user.user_shipping_details = {};
            this.user.user_primary_shipping = {};
            //
            this.getUser(3);
        },
        
        getSellpoint(){
            this.loading = true;
            service.getBusinessByUserName(this, this.$route.params.id).then(response => { //'lucas1870509088' Kedi1674857669 //lucas1870509088
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    this.header_data.name = this.sellpoint.business_name;
                    // this.header_data.componentKey++;
                    this.headerComponentKey++;
                    this.getSellpointDetails(); //reset-stores
                    this.setBusinessDetails();
                    this.getSellpointCategories();
                    //this.getSellpointProducts(); //call from items component
                    //this.getBusinessAddonProducts();
                    //this.header_data.name = "Welcome to "+this.sellpoint.business_name;
                    // this.categories = [
                    //     {category_name:'Swallow'},{category_name:'Drinks'},{category_name:'Swallow'},{category_name:'Drinks'},
                    // ]
                    this.set_categories = [
                        {category_name:'Take-out'},{category_name:'Take-in'},{category_name:'Breakfast'},{category_name:'Lunch'},{category_name:'Dinner'},{category_name:'Event'},
                    ];
                    //
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        setBusinessDetails(){
            service.getBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    //setts
                    //----------delivery-locations
                    this.business_delivery_locations = this.sellpoint.business_delivery_options;
                    //----------./delivery-locations

                    //----------bank-details
                    this.business_bank_details = this.sellpoint.business_bank_details;
                    //----------./bank-details
                } 
            }).catch((err) => {})
        },
        
        //procs
        setViewBox(view){
            if(this.set_view_box == ''){
                this.setMenuTabInnerView('');
                this.toggleSingleComponent('shareBox');
            }else{
                this.setMenuTabInnerView('setOptions');
                //
                this.set_view_box = view;
            }
            
        },

        setProcessOrder(){
            this.setMenuTabInnerView('processOrder');
        },
        resetPageBackToView(call){
            //re-set business page views
            if(call == 1){ //product
                this.$router.push('/'+this.product.product_business_ownername);
                this.setMenuTabInnerView(''); //view
            }
        },
        prepSetPageView(call,product,product_index,product_item,product_item_index){
            if(call == 1){ //product
                this.setProductView(product,product_index,product_item,product_item_index);
                this.$router.push('/'+product.product_business_ownername+'/'+product.product_url_name)
            }
        },
        setProductView(product,product_index,product_item,product_item_index){
            this.product = product;
            this.product_index = product_index;
            //
            this.product_item = product_item;
            this.product_item_index = product_item_index;
            if(Object.keys(product).length > 0){
                //this.toggleSingleComponent('productBox');
                this.setMenuTabInnerView('viewProduct');
                this.scrollPageTop();
                //this.setbg();
                let self = this;
                setTimeout(function(){ 
                    if(self.site_view == 1){
                     self.setbg()
                    }
                }, 50); //wait for 3sec and c
            }
        },

        setProductItem(product_item,product_item_index){
            this.product_item = product_item;
            this.product_item_index = product_item_index;
            //
            this.setOrderProductItem(1,product_item,this.product_index,this.product_item_index);
        },

        setProductOrderOptions(index,item,options){
            this.product_item = item;
            this.set_order_options_item_index = index;
            //this.set_product_order_options = options;
            this.set_view_box_2 = 'setProductOrderOptions';
            this.toggleSingleComponent('infoBox');
        },
        //../procs

        setbg(){
            this.componentKey++;
            //dbgg
            let el = document.getElementById('el-image');
            //dxmg
            let xel = document.getElementById('xmg');
            let xel_width = xel.offsetWidth;
            let xel_height = xel.offsetHeight;
            
            //
            if((xel_width < 300)){ //small width image
                el.style.objectFit = "scale-down";
                el.style.height = '50vh';
                //
                if((Math.abs(xel_height - xel_width) < 20) || (Math.abs(xel_width - xel_height) < 20) ){ //small width  square like image
                    el.style.objectFit = "cover";
                    el.style.height = '50vh';
                }
            }else{
                el.style.objectFit = "cover";
                el.style.height = '50vh';//xel_height;
            }
            //
            if(((xel_height/2) > xel_width) || ((xel_width/2) > xel_height)){ 
                //really big largely rectangle not square aspect ratio
            }
            //
            document.getElementById('xmg').style.display = 'none';
        },
        
        //
        handleBackFunction () {
            // Your logic
            //alert('hei--yer')
            if(this.back_track = 1){
                //handle viewProduct back
                this.setMenuTabInnerView('');
            }
        },
    
        checkBackButton: function() {
            if (
                window.performance &&
                window.performance.navigation.type ===
                    window.performance.navigation.TYPE_BACK_FORWARD &&
                this.type === "main"
            ) {
                alert('hei')
                window.location.reload();
            }
        }
},

mounted() {
    //history.pushState(null, null, '/orders');
    // window.addEventListener('popstate', function () {
    //     //alert('hei')
    //     this.$router.replace({ path: '/home' })
    // });
    //document.addEventListener("popstate", this.handleBackFunction, false);
},
    // mounted() {
    //     // if back button is pressed
    //     window.onpopstate = () => {
    //       alert("location");
    //     };
    //  },
    //mounted: function() {
        //document.addEventListener("backbutton", this.handleBackFunction(), false);
       
        // window.onpopstate = (event) => {
        //     alert('hei--u')
        //   };
        //   history.pushState({ page: 1 }, "title 1", "?page=1");
        //   history.pushState({ page: 2 }, "title 2", "?page=2");
        //   history.replaceState({ page: 3 }, "title 3", "?page=3");
         // history.back();
   // },
   // beforeDestroy: function() {
        //document.removeEventListener("backbutton", this.handleBackFunction());
   // },
    // beforeRouteLeave(to, from, next) {
    //     alert('hei')
    //     // if (from.name === 'contact' && to.name !== 'profile') {
    //     //   next({
    //     //     name: 'profile',
    //     //     params: {
    //     //       id: from.params.id
    //     //     }
    //     //   });
    //     // }
    //     // else {
    //     //   next();
    //     // }
    //   },
    created: function(){
        window.onpopstate = (event) => {
            //alert('hei--u');
            this.handleBackFunction();
        };
        // window.onpopstate = function() {
        //     alert('browser-back');
        //   };
        this.setScreenView();
        // if(localStorage.getItem('appOn')){
        //     this.show_landing = false;
        // }else{
        //     //
        //     localStorage.setItem('appOn',1); //check best unset later //use time count
        // }
        // this.menu_view["timeline"] = true;
        this.preset();
        this.getSellpoint();
        //
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Business/main.js